import { useEffect, useRef } from 'react';
import cx from 'classnames';
import { useReactDndConstructs } from '../../../../dnd/ReactDndContext';
import { EarconName, useEarcon } from '../../../../hooks/useEarcon';
import { getDndDesignTokens } from '../../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../../../theme';
import cn from './Dnd.css.json';
import './Dnd.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const DraggableTab = props => {
  const dropRef = useRef(null);
  const {
    useDrag,
    useDrop,
    getEmptyImage
  } = useReactDndConstructs();
  const earcon = useEarcon({
    source: EarconName.InputFull
  });
  const index = props.index;
  const [{
    isDragging
  }, drag, preview] = useDrag({
    // NOTE: type is now a required prop and is decoupled from item in react-dnd(v14.0.0)
    // @see - https://github.com/react-dnd/react-dnd/releases/tag/v14.0.0
    type: props.type,
    item: {
      id: props.id,
      type: props.type,
      index: props.index,
      dndPrefix: props.dndPrefix
    },
    canDrag: props.allowDrag,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end: (draggedItem, monitor) => {
      const dropResult = monitor.getDropResult();
      if (!dropResult) {
        earcon.play();
        props.onFocus?.();
      } else if (dropResult && draggedItem && dropResult.type !== draggedItem.type) {
        props.onDragEnd?.({
          draggdItem: draggedItem,
          dragIndex: draggedItem.index,
          monitor
        });
      }
    }
  });
  const [{
    styleClassName,
    collectMonitor
  }, drop] = useDrop({
    accept: props.acceptDropTypes,
    canDrop: () => props.allowDrop,
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (props.dndPrefix === item.dndPrefix) {
          if (item.index !== props.index) props.reorderTabs?.(item.index, props.index);
        } else {
          props.onDrop?.({
            droppedItem: item,
            dropIndex: props.index,
            monitor
          });
        }
        return {
          type: props.type
        };
      }
    },
    collect(monitor) {
      const dragIndex = monitor.getItem()?.index;
      const dragDndPrefix = monitor.getItem()?.dndPrefix;
      let styleClass = '';
      if (monitor.isOver() && monitor.canDrop()) {
        if (props.droppableContent.length && props.droppableContent.includes(monitor.getItem()?.type)) {
          styleClass = cn.dragOver;
        } else if (!isDragging && (dragIndex > props.index || dragDndPrefix !== props.dndPrefix)) {
          styleClass = cx(props.orientation === 'vertical' ? cn.vDropLine : cn.dropLine);
        } else if (dragIndex < props.index && !isDragging) {
          styleClass = cx(props.orientation === 'vertical' ? cn.vDropLine : cn.dropLine, cn.placeAtEnd);
        }
      }
      return {
        styleClassName: styleClass,
        collectMonitor: monitor
      };
    }
  });
  useEffect(() => {
    let timer;
    const eventParams = {
      overIndex: index,
      monitor: collectMonitor,
      droppedItem: collectMonitor.getItem(),
      droppableType: 'TAB'
    };

    /** Added a timer to handle the case of hover from right to left direction.
     * else it will call over item first and then non hover item. **/
    if (collectMonitor.isOver()) {
      timer = setTimeout(() => {
        props.onDragOver?.(eventParams);
      }, 0);
    } else {
      props.onDragLeave?.(eventParams);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [styleClassName]);
  useEffect(() => {
    preview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [preview, getEmptyImage]);
  const dt = useDesignTokens();
  const dndTokens = getDndDesignTokens(dt);
  drag(drop(dropRef));
  return /*#__PURE__*/_jsx("div", {
    ref: dropRef,
    style: dndTokens,
    className: cx(props.allowDrag && cn.draggable, isDragging && cn.draggedItem, styleClassName),
    children: props.children
  });
};
//# sourceMappingURL=DraggableTab.js.map